
import {
  LIGHTING_GUIDE_ROUTE,
  lightingGuideAvailable,
} from '@/utils/lightingGuide'
import { locales } from '@/utils/locales'
import { waitForPageFetches } from '@/utils/pageFetches'

export default {
  name: 'FooterBottom',
  data() {
    return {
      openGroup: null,
    }
  },
  computed: {
    alternateUrls() {
      return this.$store.state.alternate_urls
    },
    currentYear() {
      return new Date().getFullYear()
    },
    logoSrcset() {
      return `${require('~/assets/images/logo2.png?original')} 1x, ${require('~/assets/images/logo2@2x.png?original')} 2x`
    },
    localePhone() {
      const match = locales.find(locale => locale.code === this.$i18n.locale)
      return (match || locales[0]).phone
    },
    dialablePhone() {
      return this.localePhone.replace(/[^\d+]/g, '')
    },
    navGroups() {
      return [
        {
          id: 'footer-find',
          title: this.$t('components.footerBottom.findYourLedTitle'),
          links: [
            {
              to: this.localePath({ name: 'marques-vehicules' }),
              label: this.$t('components.footerBottom.allVehicleBrandsLink'),
            },
            {
              to: this.localePath({ name: 'blog-led-accessoires-vehicules' }),
              label: this.$t(
                'components.footerBottom.allAboutLedForVehiclesLink'
              ),
            },
            ...(lightingGuideAvailable(this.$i18n.locale)
              ? [
                  {
                    to: this.localePath({ name: LIGHTING_GUIDE_ROUTE }),
                    label: this.$t('components.footerBottom.lightingGuideLink'),
                  },
                ]
              : []),
            {
              to: this.localePath({ name: 'bonnes-affaires' }),
              label: this.$t('components.footerBottom.dealsLink'),
            },
            {
              to: this.localePath({ name: 'code-promo' }),
              label: this.$t('components.footerBottom.promoCodesLink'),
            },
          ],
        },
        {
          id: 'footer-help',
          title: this.$t('components.footerBottom.helpAndOrdersTitle'),
          links: [
            {
              to: this.localePath({ name: 'contact' }),
              label: this.$t('components.footerBottom.contactUsLink'),
            },
            {
              to: this.localePath({ name: 'livraison' }),
              label: this.$t('components.footerBottom.deliveryMethodsLink'),
            },
            {
              to: this.localePath({ name: 'paiement-securise' }),
              label: this.$t('components.footerBottom.securePaymentLink'),
            },
            {
              to: this.localePath({ name: 'retour-remboursement' }),
              label: this.$t('components.footerBottom.returnAndRefundLink'),
            },
            {
              to: this.localePath({ name: 'compte-pro' }),
              label: this.$t(
                'components.footerBottom.proAccountAdvantagesLink'
              ),
            },
          ],
        },
        {
          id: 'footer-company',
          title: this.$t('components.footerBottom.companyTitle'),
          links: [
            {
              to: this.localePath({
                name: 'magasin-excideuil',
                hash: '#qui-sommes-nous',
              }),
              label: this.$t('components.footerBottom.whoAreWeLink'),
            },
            {
              to: this.localePath({ name: 'qui-sommes-nous-partenaires' }),
              label: this.$t('components.footerBottom.ourPartnersLink'),
            },
            {
              to: this.localePath({ name: 'magasin-excideuil' }),
              label: this.$t('components.footerBottom.ourStoreLink'),
            },
            {
              href: 'https://www.google.com/maps/place/AGM-VISION+(Garage+Andreau)/@45.3369617,1.0539467,17z/data=!3m1!4b1!4m5!3m4!1s0x47ff39c959cff17b:0x2072f224f484ee71!8m2!3d45.336958!4d1.0561354',
              label: this.$t(
                'components.footerBottom.locateUsOnGoogleMapsLink'
              ),
            },
          ],
        },
      ]
    },
    legalLinks() {
      return [
        {
          to: this.localePath({ name: 'plan-du-site' }),
          label: this.$t('components.footerBottom.sitemapLink'),
        },
        {
          to: this.localePath({ name: 'mentions-legales' }),
          label: this.$t('components.footerBottom.legalNoticeLink'),
        },
        {
          to: this.localePath({ name: 'cgv' }),
          label: this.$t('components.footerBottom.generalTermsOfSaleLink'),
        },
        {
          to: this.localePath({ name: 'charte-donnees-personnelles' }),
          label: this.$t('components.footerBottom.personalDataCharterLink'),
        },
      ]
    },
    socialNetworks() {
      return [
        {
          href: 'https://www.facebook.com/agmvision/',
          icon: ['fab', 'facebook-square'],
          label: this.$t('components.footerBottom.facebookAriaLabel'),
        },
        {
          href: 'https://www.instagram.com/agm_vision/',
          icon: ['fab', 'instagram'],
          label: this.$t('components.footerBottom.instagramAriaLabel'),
        },
        {
          href: 'https://www.youtube.com/@agmvision',
          icon: ['fab', 'youtube'],
          label: this.$t('components.footerBottom.youtubeAriaLabel'),
        },
        {
          href: 'https://www.tiktok.com/@agmvision',
          icon: ['fab', 'tiktok'],
          label: this.$t('components.footerBottom.tiktokAriaLabel'),
        },
      ]
    },
  },
  methods: {
    toggleGroup(id) {
      this.openGroup = this.openGroup === id ? null : id
    },
    localeSwitchPath(code) {
      if ((this.$store.state.restricted_locales || []).includes(code)) {
        return this.localePath({ name: 'index' }, code)
      }
      const target =
        this.alternateUrls[code] || this.switchLocalePath(code) || '/'
      const queryIndex = target.indexOf('?')

      return queryIndex === -1 ? target : target.slice(0, queryIndex)
    },
    async switchLocale(event, code) {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return
      }
      event.preventDefault()
      await waitForPageFetches(this.$nuxt)
      this.$router.push(this.localeSwitchPath(code))
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth',
      })
    },
  },
}
